import React from "react";
import Reveal from "../ui/Reveal";

function cn(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function PageSectionHeader({
  eyebrow,
  title,
  description,
  children,
  className = "",
}) {
  return (
    <Reveal>
      <section
        className={cn(
          "relative isolate overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-950",
          className
        )}
      >
        <div className="absolute -right-24 -top-24 h-64 w-64 rounded-full bg-[#1277B9]/10 blur-3xl" />
        <div className="absolute -bottom-28 left-8 h-64 w-64 rounded-full bg-sky-300/20 blur-3xl dark:bg-sky-500/10" />

        <div className="relative grid gap-5 px-5 py-7 sm:px-7 md:py-8 lg:grid-cols-[1fr_auto] lg:items-end">
          <div>
            {eyebrow && (
              <p className="text-xs font-bold uppercase tracking-[0.22em] text-[#1277B9]">
                {eyebrow}
              </p>
            )}

            <h1 className="mt-2 text-3xl font-bold tracking-tight text-slate-950 dark:text-white md:text-4xl">
              {title}
            </h1>

            {description && (
              <p className="mt-4 max-w-3xl text-sm leading-7 text-slate-600 dark:text-slate-300 md:text-base">
                {description}
              </p>
            )}
          </div>

          {children && <div className="lg:min-w-56">{children}</div>}
        </div>
      </section>
    </Reveal>
  );
}